import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import { Upload } from './forms/_upload.js';
import { QuantitySelector } from './forms/_quantityselector.js';
import { Validation } from './forms/_validation.js';
export var Formulaire = /*#__PURE__*/function () {
  function Formulaire(prmForm) {
    var prmTranslation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    _classCallCheck(this, Formulaire);
    // Init input type specific behavior
    this.formular = prmForm;
    this.translation = prmTranslation;
    this.initUploadInput();
    this.initQuantitySelectors();
    this.initValidation();
  }
  return _createClass(Formulaire, [{
    key: "initUploadInput",
    value: function initUploadInput() {
      var uploadList = this.formular.querySelectorAll('.js-input-upload');
      for (var i = 0; i < uploadList.length; i++) {
        new Upload(uploadList[i], this.translation);
      }
    }
  }, {
    key: "initQuantitySelectors",
    value: function initQuantitySelectors() {
      var quantitySelectorList = this.formular.querySelectorAll('.js-input-counter');
      for (var i = 0; i < quantitySelectorList.length; i++) {
        new QuantitySelector(quantitySelectorList[i]);
      }
    }
  }, {
    key: "initValidation",
    value: function initValidation() {
      new Validation(this.formular);
    }
  }]);
}();